<div class="public-nav-wrapper">
  <div class="nav-container justify-content-space-between">
    <twc-logo logo path="assets/images/Nexus.svg"></twc-logo>
  </div>
</div>
